import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { connectSocket, disconnectSocket } from "../lib/socket";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem("pt_token")) { setUser(false); return; }
    api.get("/auth/me").then((r) => { setUser(r.data); connectSocket(); })
      .catch(() => { localStorage.removeItem("pt_token"); setUser(false); });
  }, []);

  const signIn = useCallback((data) => {
    localStorage.setItem("pt_token", data.token);
    setUser(data.user);
    connectSocket();
  }, []);

  const signOut = useCallback(() => {
    localStorage.removeItem("pt_token");
    disconnectSocket();
    setUser(false);
  }, []);

  return <AuthCtx.Provider value={{ user, setUser, signIn, signOut }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
